/* 三國逗陣打 · 戰報卡：把一場的戰績畫成 1200×630 的圖（社群預覽比例），附挑戰連結 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';

const W = 1200, H = 630;
const FCOL = { shu: ['#1f4a30', '#4c9463'], wu: ['#4a1d1a', '#c2463a'], wei: ['#1b2650', '#4a74c4'] };
const FNAME = { shu: '蜀', wu: '吳', wei: '魏' };
const BATTLE_NAME = { chibi: '赤壁之戰', guandu: '官渡之戰', changban: '長坂坡之戰' };
const GCOL = { S: '#ffcf4a', A: '#e05a3a', B: '#5aa0e0', C: '#9aa39a', D: '#7a7a7a' };
const SERIF = '"Noto Serif TC", "Songti TC", serif', SANS = '"Noto Sans TC", "PingFang TC", sans-serif';

// 墨跡筆刷：用一串抖動的寬線段做出書法感的底紋
function brush(ctx, x0, y0, x1, y1, w, col, seed) {
  let s = seed || 1; const r = () => { s = (s * 16807) % 2147483647; return s / 2147483647; };
  ctx.save(); ctx.fillStyle = col;
  const n = 26;
  for (let i = 0; i < n; i++) {
    const u = i / (n - 1), x = x0 + (x1 - x0) * u, y = y0 + (y1 - y0) * u + (r() - 0.5) * w * 0.15;
    const ww = w * (0.55 + 0.45 * Math.sin(Math.PI * Math.min(1, u * 1.3))) * (0.85 + r() * 0.3);
    ctx.globalAlpha = 0.5 + r() * 0.4;
    ctx.beginPath(); ctx.ellipse(x, y, ww * 0.9, ww / 2, -0.08, 0, Math.PI * 2); ctx.fill();
  }
  ctx.restore();
}

function seal(ctx, x, y, size, text, col) {
  ctx.save(); ctx.translate(x, y); ctx.rotate(-0.08);
  ctx.fillStyle = col; ctx.globalAlpha = 0.92;
  ctx.beginPath(); ctx.roundRect ? ctx.roundRect(-size / 2, -size / 2, size, size, size * 0.12) : ctx.rect(-size / 2, -size / 2, size, size); ctx.fill();
  ctx.globalAlpha = 1; ctx.strokeStyle = 'rgba(255,240,210,.85)'; ctx.lineWidth = size * 0.05;
  ctx.strokeRect(-size * 0.4, -size * 0.4, size * 0.8, size * 0.8);
  ctx.fillStyle = '#fff6e0'; ctx.font = `900 ${size * 0.62}px ${SERIF}`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.fillText(text, 0, size * 0.04);
  ctx.restore();
}

function heroPose(h) {
  return SG.poseOf(h, 'idle', 0.25);
}

// r：SG.Meta.record 的回傳值；h：本場使用的武將（可能是換過造型的副本）
function draw(cv, r, h, opts) {
  opts = opts || {};
  const dpr = opts.scale || 1;
  cv.width = W * dpr; cv.height = H * dpr;
  const ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  const s = r.s, [dark, mid] = FCOL[h.faction] || FCOL.shu;
  // 底：陣營色漸層＋宣紙紋
  const g = ctx.createLinearGradient(0, 0, W, H); g.addColorStop(0, dark); g.addColorStop(0.55, '#14110f'); g.addColorStop(1, '#0c0b0a');
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  ctx.globalAlpha = 0.06; ctx.fillStyle = '#fff';
  for (let i = 0; i < 900; i++) { const x = (i * 733) % W, y = (i * 389) % H; ctx.fillRect(x, y, 1 + (i % 3), 1); }
  ctx.globalAlpha = 1;
  // 大字背景：陣營
  ctx.save(); ctx.fillStyle = 'rgba(255,255,255,.045)'; ctx.font = `900 520px ${SERIF}`; ctx.textBaseline = 'middle'; ctx.fillText(FNAME[h.faction] || '', -30, H / 2 + 20); ctx.restore();
  // 墨痕與光
  brush(ctx, 70, 592, 590, 572, 62, mid, 7);
  const rg = ctx.createRadialGradient(300, 330, 20, 300, 330, 330); rg.addColorStop(0, (h.aura || h.fx || '#ffd46b') + '55'); rg.addColorStop(1, 'transparent');
  ctx.fillStyle = rg; ctx.fillRect(0, 0, 640, H);
  // 武將
  ctx.save(); ctx.translate(320, 585); ctx.scale(4.3, 4.3);
  ctx.fillStyle = 'rgba(0,0,0,.35)'; ctx.beginPath(); ctx.ellipse(0, 0, 34, 7, 0, 0, Math.PI * 2); ctx.fill();
  SG.drawHero(ctx, h, heroPose(h), 0);
  ctx.restore();
  // 右側文字
  const X = 640;
  ctx.textBaseline = 'alphabetic'; ctx.textAlign = 'left';
  ctx.fillStyle = '#caa24f'; ctx.font = `500 22px ${SANS}`;
  ctx.fillText(`三國逗陣打 · ${BATTLE_NAME[s.battle] || '赤壁之戰'}${s.mode === 'quick' ? '（速戰）' : ''} · ${SG.Meta.today()}`, X, 70);
  ctx.fillStyle = s.win ? '#ffd46b' : '#c9b8ff'; ctx.font = `900 40px ${SERIF}`;
  ctx.fillText(s.win ? '大 勝' : '戰 敗', X, 128);
  ctx.fillStyle = '#ece4d2'; ctx.font = `900 92px ${SERIF}`;
  ctx.fillText(s.title[0], X, 232);
  ctx.fillStyle = '#a39e93'; ctx.font = `400 24px ${SANS}`;
  ctx.fillText(`${h.name}${h.skinName ? '・' + h.skinName : ''}　${s.title[1]}`, X, 274);
  // 數據列
  const stats = [['擊殺', s.k], ['陣亡', s.d], ['助攻', s.a], ['等級', s.lv]];
  stats.forEach(([k, v], i) => {
    const x = X + i * 130;
    ctx.fillStyle = '#ece4d2'; ctx.font = `700 56px ${SERIF}`; ctx.fillText(String(v), x, 372);
    ctx.fillStyle = '#a39e93'; ctx.font = `400 20px ${SANS}`; ctx.fillText(k, x, 402);
  });
  ctx.fillStyle = 'rgba(236,228,210,.2)'; ctx.fillRect(X, 428, 500, 1);
  ctx.fillStyle = '#ece4d2'; ctx.font = `500 22px ${SANS}`;
  const mm = String(Math.floor(s.t / 60)).padStart(2, '0') + ':' + String(Math.floor(s.t % 60)).padStart(2, '0');
  ctx.fillText(`對將傷害 ${Math.round(s.stat.dmgHero).toLocaleString()}　拆塔 ${s.stat.towers}　用時 ${mm}`, X, 466);
  ctx.fillStyle = '#caa24f'; ctx.fillText(`戰功分 ${s.score.toLocaleString()}　軍階 ${r.rank1.name}`, X, 502);
  // 挑戰標語
  ctx.fillStyle = '#ffffff'; ctx.font = `900 34px ${SERIF}`;
  ctx.fillText(opts.cta || '你能超越這一戰嗎？', X, 572);
  ctx.fillStyle = '#a39e93'; ctx.font = `400 18px ${SANS}`;
  ctx.fillText('點連結，用同一名武將挑戰', X, 600);
  // 評價印章
  seal(ctx, 1110, 120, 120, s.grade, GCOL[s.grade] === '#ffcf4a' ? '#b8331f' : '#8e2b22');
  ctx.fillStyle = GCOL[s.grade]; ctx.font = `700 18px ${SANS}`; ctx.textAlign = 'center'; ctx.fillText('評價', 1110, 202);
  return cv;
}

function link(r) {
  let name = SG.Meta.profile.name || '';
  try { name = name || JSON.parse(localStorage.getItem('sankuo-online') || '{}').name || ''; } catch (e) { /* 沒有署名也能分享 */ }
  const code = SG.Meta.encodeChallenge(r, name);
  const base = location.href.split('#')[0].split('?')[0];
  return `${base}?c=${code}`;
}
function text(r, h) {
  const s = r.s;
  return `我在《三國逗陣打》用${h.name}打出「${s.title[0]}」${s.k}/${s.d}/${s.a}，評價 ${s.grade}！你能超越嗎？`;
}

// 分享：能直接分享圖片就分享圖片（手機），否則複製連結；回傳一段給玩家看的結果文字
async function share(cv, r, h) {
  const url = link(r), msg = text(r, h);
  try {
    const blob = await new Promise((res) => cv.toBlob(res, 'image/png'));
    const file = blob && typeof File !== 'undefined' ? new File([blob], 'sankuo-battle.png', { type: 'image/png' }) : null;
    if (file && navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text: msg, url }); return '已開啟分享'; }
    if (navigator.share) { await navigator.share({ text: msg, url }); return '已開啟分享'; }
  } catch (e) { if (e && e.name === 'AbortError') return ''; }
  return copy(msg + '\n' + url);
}
async function copy(t) {
  try { await navigator.clipboard.writeText(t); return '已複製，貼給朋友吧'; } catch (e) { return '無法自動複製，請手動選取連結'; }
}
async function copyImage(cv) {
  try {
    const blob = await new Promise((res) => cv.toBlob(res, 'image/png'));
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
    return '戰報圖已複製';
  } catch (e) {
    try { const a = document.createElement('a'); a.href = cv.toDataURL('image/png'); a.download = 'sankuo-battle.png'; a.click(); return '已下載戰報圖'; } catch (e2) { return '這個環境不能存圖，請截圖'; }
  }
}

SG.Share = { draw, link, text, share, copy, copyImage, seal, brush };
